import { useArticles } from "@/hooks/useArticles";
import { Link } from "react-router-dom";
import HeroSection from "@/components/HeroSection";
import Lead from "@/components/Lead";
import FiveRoles from "@/components/FiveRoles";
import ArticlesSection from "@/components/ArticlesSection";
import Community from "@/components/Community";
import EditorIntro from "@/components/EditorIntro";
import ContactSection from "@/components/ContactSection";

const Index = () => {
  const { data: articles, isLoading } = useArticles();

  return (
    <div className="min-h-screen relative">
      {/* 光の帯 */}
      <div className="light-band" />
      {/* ノイズテクスチャ */}
      <div className="noise-overlay" />

      {/* Hero Section */}
      <HeroSection />

      {/* Lead */}
      <Lead />

      {/* Five Roles - 5つの部屋へのリンク */}
      <div id="roles">
        <FiveRoles />
      </div>

      {/* Journal (Recent Posts / Blog) */}
      <div className="relative">
        <div id="journal">
          <ArticlesSection articles={articles} isLoading={isLoading} />
        </div>
      </div>

      {/* Community */}
      <Community />

      {/* Profile */}
      <div className="relative">
        <div id="profile">
          <EditorIntro />
        </div>
      </div>

      {/* Contact */}
      <div className="relative">
        <div id="contact">
          <ContactSection />
        </div>
      </div>

      {/* Footer */}
      <footer className="py-20 relative">
        <div className="container mx-auto px-12 text-center">
          <p className="text-sm text-muted-foreground/50 font-light tracking-wide">
            特に何もなくても、思い出したときにでも、どうぞ。
          </p>
          
          <div className="mt-12">
            <Link 
              to="/privacy-policy"
              className="text-xs font-display tracking-[0.1em] text-muted-foreground/30 hover:text-muted-foreground/50 transition-colors duration-500"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
